import { delay, http, HttpResponse } from 'msw';
import { IGetTruckerTypeReturn } from 'services/trucker';
import { mockedDataSuggested, mockedMetaSuggested } from './truckersSuggested';

const trucker = [
  http.get(`${process.env.BFF_URL}freights/:freight_id/truckers`, async () => {
    await delay(1500);

    return HttpResponse.json<IGetTruckerTypeReturn>({
      data: mockedDataSuggested,
      meta: {
        ...mockedMetaSuggested,
      },
    });
  }),
];

export { trucker };
